module.exports = __webpack_public_path__ + "img/9.c2e855a1.jpg";